import { render, staticRenderFns } from "./PatientSummary.vue?vue&type=template&id=f7d52482"
import script from "./PatientSummary.vue?vue&type=script&lang=js"
export * from "./PatientSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports